var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-navigation"},_vm._l((_vm.items),function(item){return _c('signup-navigation-item',{key:item.id,attrs:{"id":item.id,"title":item.title,"valid":item.valid,"active":item.active}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }